module.exports = __webpack_public_path__ + "img/circle_dark.cf9e3147.png";